import { Body, Col, Row, styled, useTheme } from '@teko/ds-desktop';
import { AddAlternativeOutlined } from '@teko/ds-icon';
import { Spinner } from 'components/desktop/atoms';
import { MODE_TERMINAL_PICKER, useDistanceTerminalContext } from 'contexts';
import { useAddresses } from 'hooks';
import { t } from 'i18n';
import { useGetDistanceTerminal } from '../../useGetDistanceTerminal';
import { convertFullAddress } from '../../utils';
import { HeaderModal } from '../HeaderModal';
import { WrapperError } from '../StepEnterAddress/EnterAddress';
import { LocationPickerItem } from './LocationPickerItem';

export const ModeListAddress = ({
  onClosePopup,
}: {
  onClosePopup: () => void;
}) => {
  const {
    locations = [],
    location: currentLocation,
    setModeTerminalPicker,
    messageError,
    isLoadingGetDistanceTerminals,
  } = useDistanceTerminalContext();
  const { loading: loadingAddress, addresses } = useAddresses();

  const { getDistanceTerminalsByAddress } = useGetDistanceTerminal();

  const theme = useTheme();

  return (
    <>
      <HeaderModal
        displayBackButton={false}
        onClosePopup={onClosePopup}
        title={t('Chọn khu vực của bạn')}
        subTitle={t('Để biết chính xác tồn kho và thời gian giao hàng')}
      />
      <BodyModal>
        <ListLocation>
          {loadingAddress || isLoadingGetDistanceTerminals ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: 300,
              }}
            >
              <Spinner />
            </div>
          ) : (
            [
              ...(addresses || []),
              ...locations.map((l) => {
                return { ...l, name: '', isDefault: false, telephone: '' };
              }),
            ]
              .map((a) => {
                return {
                  address: a.address,
                  wardName: a.wardName || '',
                  provinceName: a.provinceName || '',
                  wardCode: a.wardCode || '',
                  provinceCode: a.provinceCode || '',
                  name: a.name,
                  isDefault: a.isDefault,
                  telephone: a.telephone,
                };
              })
              .map((location, index) => {
                const isActive = !currentLocation
                  ? false
                  : convertFullAddress(location) ===
                    convertFullAddress(currentLocation);
                return (
                  <LocationPickerItem
                    onClick={() => {
                      if (isActive) {
                        return;
                      }
                      getDistanceTerminalsByAddress(location, true);
                    }}
                    telephone={location.telephone}
                    isDefault={!!location.isDefault}
                    name={location.name || ''}
                    address={`${
                      location.address ? `${location.address},` : ''
                    } ${location.wardName ? `${location.wardName},` : ''} ${
                      location.provinceName ? `${location.provinceName}` : ''
                    }`}
                    key={index}
                    active={isActive}
                  />
                );
              })
          )}
        </ListLocation>
        <Row
          onClick={() =>
            setModeTerminalPicker?.(MODE_TERMINAL_PICKER.ENTER_ADDRESS)
          }
          padding="s12"
          justify="start"
          align="middle"
          style={{ cursor: 'pointer' }}
        >
          <AddAlternativeOutlined size={16} color={theme.colors.primary} />
          <Body style={{ marginLeft: 4 }} color={theme.colors.primary}>
            {t('Thêm địa chỉ')}
          </Body>
        </Row>
      </BodyModal>
      {messageError && <WrapperError>{messageError}</WrapperError>}
    </>
  );
};

const BodyModal = styled.div`
  height: 340px;
  margin-bottom: 10px;
`;

const ListLocation = styled(Col)`
  height: 300px;
  overflow-y: auto;
`;
